import { createFileRoute } from "@tanstack/react-router";
import LandingPageView from "@/components/views/LandingPage/landing-page.view";

export const Route = createFileRoute("/")({
    component: RouteComponent,
});

function RouteComponent() {
    return <LandingPageView />;
}
